const KnowledgeCenterLink = () => {
  return (
    <div className="margin-top-2 margin-bottom-5">
      <a
        className="usa-link"
        href="https://tdp-project-updates.app.cloud.gov/knowledge-center/viewing-error-reports.html"
        target="_blank"
        aria-label="Knowledge Center error reports guidance"
        rel="noreferrer"
      >
        Visit the Knowledge Center for further guidance on reviewing error
        reports
      </a>
    </div>
  )
}

export default KnowledgeCenterLink
